import script from "./header-section.vue?vue&type=script&lang=ts&setup=true"
export * from "./header-section.vue?vue&type=script&lang=ts&setup=true"

import "./header-section.vue?vue&type=style&index=0&id=6fab27f9&lang=less&scoped=true"
import "./header-section.vue?vue&type=style&index=1&id=6fab27f9&lang=less"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.13_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fab27f9"]])

export default __exports__